import { create } from 'apisauce';

import auth from './auth';
import parseGroupMetadata from '../utils/parseGroupMetadata';

const authResultKey = 'vrpatients::auth::result';
let authResult = JSON.parse(localStorage.getItem(authResultKey));

const userManagement = create({
  baseURL: process.env.VUE_APP_USERS_SERVICE_URL,
  headers: {
    Authorization: authResult ? `Bearer ${authResult.idToken}` : undefined,
  },
});

userManagement.isKeyOwner = async function isKeyOwner() {
  const groups = authResult.idTokenPayload['https://vrpatients.com/groups'];
  const userId = authResult.idTokenPayload.sub;
  const orgId = groups && groups[0];
  const groupDetailsResponse = await userManagement.get(
    `/extension/groups/${orgId}`,
  );
  if (!groupDetailsResponse.ok) {
    console.error(groupDetailsResponse);
    return false;
  }
  const group = groupDetailsResponse.data;
  const groupWithMetadata = { ...group, metadata: parseGroupMetadata(group) };
  return groupWithMetadata.metadata.ownerId === userId;
};

userManagement.isOrgActive = async function isOrgActive() {
  const groups = authResult.idTokenPayload['https://vrpatients.com/groups'];
  const orgId = groups && groups[0];
  const groupDetailsResponse = await userManagement.get(
    `/extension/groups/${orgId}`,
  );
  if (!groupDetailsResponse.ok) {
    console.error(groupDetailsResponse);
    return false;
  }
  const group = groupDetailsResponse.data;
  return !parseGroupMetadata(group).inactive;
};

userManagement.getGroupMembers = async function getGroupMembers(orgId, includeDeleted = false, overrideRole = undefined, offset, count) {
  // Use fetchAll to get full list of users (not just first 25)
  const response = await this.get(
    `/fetchall/users?orgId=${orgId}&includeDeleted=${includeDeleted}${overrideRole ? `&overrideRole=${overrideRole}` : ''}${offset || count ? `&offset=${offset}` : ''}${count ? `&count=${count}` : ''}`,
  );

  // Filter out deleted users
  return includeDeleted ? response.data.users : response.data.users.filter(u => u.created_at);
};
userManagement.getOrgMembers = userManagement.getGroupMembers;

userManagement.getKeyOwner = async function getKeyOwner(groupId) {
  const response = await userManagement.get(`/extension/groups/${groupId}/key-owner`);
  return response.data;
};

userManagement.addResponseTransform((response) => {
  if (!response.ok) {
    throw response.data || new Error(`An unknown error occurred. ${response.status ? 'Error code ' + response.status : ''}`);
  }
});

auth.on('sessionRenewed', (updatedAuthResult) => {
  authResult = updatedAuthResult;
  userManagement.setHeader(
    'Authorization',
    `Bearer ${updatedAuthResult.idToken}`,
  );
});

export default userManagement;
